import { Box, Grid, Paper, Stack, TextField } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { dateformat } from '../../helpers';
import { ModalComponent } from '../../widgets';
import FechasPersonalizada from '../../widgets/FechasPersonalizada';
import BotonComponent from '../dashboard/components/BotonNuevo';
import { allAccesosAction, setActivoAccesosAction } from './AccesosAction';
import { PARAMS_ACCESOS } from './AccesosReducer';
import BotonFechasComponent from './components/BotonFechas';
import ListadoAccesos from './components/ListadoAccesos';
import SwitchFechaComponent from './components/SwitchFecha';
import ReportesAccesos from './reportes/ReportesAccesos';

const AccesosView = () => {
  const dispatch = Redux.useDispatch();

  const accesosStore = Redux.useSelector((state) => state.accesos);
  const [openModalReporte, setOpenModalReporte] = React.useState(false);

  const [isRango, setIsRango] = React.useState(false);
  const [isFuturo, setIsFuturo] = React.useState(true);

  const getData = async (object) => {
    if (!accesosStore.params.idEntidad) return;

    const payload = {
      ...accesosStore.params,
      ...object,
    };
    dispatch({
      type: PARAMS_ACCESOS,
      payload,
    });
    await allAccesosAction(dispatch, payload);
  };

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        <BotonComponent
          click={async () => {
            await setActivoAccesosAction(dispatch, null);
            await allAccesosAction(dispatch, accesosStore.params);
          }}
          disabled={accesosStore.loadingAll || accesosStore.all.length === 0}
          white
          text={accesosStore.loadingAll ? 'Actualizando...' : 'Actualizar'}
          mr={2}
        />
        <BotonComponent
          text="EXPORTAR PDF"
          click={() => setOpenModalReporte(true)}
          blue
          disabled={accesosStore.all.length === 0}
          downloadIcon
          mr={2}
        />
      </Grid>
      <Grid item md={12}>
        <Paper elevation={2} sx={{ width: '100%', p: 2 }}>
          <Grid
            container
            spacing={1}
            sx={{ display: 'flex', alignItems: 'center' }}
          >
            <Grid item md={isRango ? 3 : 4}>
              <TextField
                fullWidth
                size="small"
                id="accesos_buscador"
                label="Identificación, nombre o apellido"
                value={accesosStore.params.q}
                onChange={(e) =>
                  dispatch({
                    type: PARAMS_ACCESOS,
                    payload: {
                      ...accesosStore.params,
                      q: e.target.value,
                    },
                  })
                }
              />
            </Grid>
            <Grid item md={isRango ? 3 : 4}>
              <Stack direction="row" alignItems="center">
                <BotonFechasComponent
                  futuro={isFuturo}
                  dateRango={async (start, end) => {
                    getData({
                      entrada: dateformat(start, {}),
                      salida: dateformat(end, {}),
                    });
                  }}
                  setIsRango={(e) => setIsRango(e)}
                />
                {accesosStore.params.entrada === accesosStore.params.salida ||
                  (!isRango && (
                    <Box sx={{ ml: 2 }}>
                      <SwitchFechaComponent
                        value={isFuturo}
                        onClickLeft={() => setIsFuturo(false)}
                        onClickRigth={() => setIsFuturo(true)}
                        onChange={(e) => setIsFuturo(e.target.checked)}
                      />
                    </Box>
                  ))}
              </Stack>
            </Grid>
            {isRango && (
              <FechasPersonalizada
                startDate={accesosStore.params.entrada}
                endDate={accesosStore.params.salida}
                onStart={(entrada) => {
                  if (!entrada) return;
                  getData({ entrada });
                }}
                onEnd={(salida) => {
                  if (!salida) return;
                  getData({ salida });
                }}
              />
            )}
          </Grid>
        </Paper>
      </Grid>
      <Grid item md={12}>
        <ListadoAccesos setOpenModalReporte={(val) => {}} />
      </Grid>

      <ModalComponent
        id="modalPdf"
        title="Reporte de accesos"
        open={openModalReporte}
        maxWidth="lg"
        onClose={() => setOpenModalReporte(!openModalReporte)}
      >
        <ReportesAccesos />
      </ModalComponent>
    </Grid>
  );
};

export default AccesosView;
